<template>
  <section
    class="kik-rte-container mobile:mx-3 [&_a]:underline [&_h1]:!font-light [&_h2]:!font-light [&_h3]:!font-light [&_h4]:!font-light [&_h5]:!font-light [&_p]:my-4"
    :data-ab-id="dataAbId"
  >
    <div v-html="contentRTE" />
  </section>
</template>

<script lang="ts" setup>
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const { $domain } = useNuxtApp();

interface Props {
  content?: string | undefined;
  dataAbId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  content: undefined,
});

const contentRTE = computed(() => magnoliaGetters.resolveRichTextContentAssetLinks(props?.content, $domain.cmsAssetDomainPath));
</script>

<style lang="scss">
.kik-rte-container {
  table {
    border-collapse: collapse;
    @media (max-width: 767px) {
      width: auto !important;
    }

    td table td, th table td {
      border: 0;
      border-top: 1px solid #aaa;
      border-right: 1px solid #aaa;
      border-bottom: 1px solid #aaa;
    }

    td {
      padding: 5px;
    }
  }

  @media (max-width: 1023px) {
    padding: 0 var(--spacer-lg);
  }

  @include for-mobile {
    padding: 0;
  }
}
</style>
